<template>
  <v-navigation-drawer v-model="drawer" :rail.sync="mini" width="300" @click="mini = false">
    <v-list-item
        nav
        class="px-2"
    >
      <template v-slot:prepend>
        <v-avatar :rounded="0" style="--v-avatar-height: 40px;">
          <v-img :src="logoUrl"></v-img>
        </v-avatar>
      </template>

      <v-list-item-title>
        <h1>{{ $t('ЭТП') }}</h1>
      </v-list-item-title>

      <v-list-item-subtitle class="subTitle">
        {{ $t('Торговая площадка') }}
      </v-list-item-subtitle>

      <template v-slot:append>
        <v-btn
          icon="mdi-chevron-left"
          variant="text"
          @click.stop="mini = !mini"
        />
      </template>
    </v-list-item>

    <v-divider />

    <v-list density="compact" nav @click.stop>
      <div v-for="(item, i) in menu">
        <v-list-item
          v-if="!item.children"
          :key="`subheader-${i}`"
          :to="item.path"
          :prepend-icon="`mdi-${item.icon}`"
        >
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group v-else>
          <template #activator>
            <v-list-item-title>
              <v-icon>{{ `mdi-${item.icon}` }}</v-icon>
              {{ item.name }}
            </v-list-item-title>
          </template>

          <template v-for="(subItem, j) in item.children">
            <v-list-item
              v-if="!subItem.children"
              class="ml-5"
              :key="`subheader-${j}`"
              :to="subItem.path"
              :append-icon="`mdi-${subItem.icon}`"
            >
              <v-list-item-title class="ml-0">
                {{ subItem.name }}
              </v-list-item-title>
            </v-list-item>

            <v-list-group v-else color="blue-lighten-1">
              <template #activator>
                <v-list-item-title>
                  <v-icon>{{ `mdi-${subItem.icon}` }}</v-icon>
                  {{ subItem.name }}
                </v-list-item-title>
              </template>

              <div v-for="(subSubItem, k) in subItem.children">
                <v-list-item
                  :key="`subheader-${k}`"
                  color="blue-lighten-1"
                  :value="true"
                  :to="subSubItem.path"
                >
                  <v-list-item-title>{{ subSubItem.name }}</v-list-item-title>
                </v-list-item>
              </div>
            </v-list-group>
          </template>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    menu: {
      type: [Array, Object],
      required: true,
    },
    logoUrl: {
      type: String,
      required: true,
    },
    emitter: {
      required: true,
    },
  },
  data() {
    return {
      drawer: true,
      mini: false,
    };
  },
  created() {
    this.emitter.on('toogleDrawer', data => {
      this.drawer = this.drawer ? data.false : data.true;
    });
    //this.$root.$refs.NavMenu = this;
  },
};
</script>
<style scoped>
.subTitle {
  font-size: 10px;
  color: rgb(var(--black-color));
  white-space: nowrap;
}
</style>